module.exports = __webpack_public_path__ + "img/icon-currency.8ee43e0a.svg";